import './LogoLoader.css';

const LogoLoader = ({ open, message = 'Loading...' }) => {
  if (!open) return null;
  return (
    <div
      className="logo-backdrop"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 36,
      }}>

        {/* Logo blocks — 3D flip reveal in sequence */}
        <div style={{ position: 'relative', width: 90, height: 74, perspective: 400 }}>
          {/* Red — bottom-left */}
          <div style={{
            position: 'absolute', width: 36, height: 36, background: '#cc2b2b',
            borderRadius: 6, bottom: 0, left: 0,
            animation: 'll-tileFlip 2s ease-in-out infinite',
            animationDelay: '0s',
            boxShadow: '0 0 24px rgba(204,43,43,0.6)',
          }} />
          {/* Green — center, tall */}
          <div style={{
            position: 'absolute', width: 30, height: 52, background: '#3aaa5c',
            borderRadius: 6, bottom: 0, left: 30,
            animation: 'll-tileFlip 2s ease-in-out infinite',
            animationDelay: '0.3s',
            boxShadow: '0 0 24px rgba(58,170,92,0.6)',
          }} />
          {/* Blue — top-right */}
          <div style={{
            position: 'absolute', width: 34, height: 34, background: '#2d6db5',
            borderRadius: 6, top: 0, right: 0,
            animation: 'll-tileFlip 2s ease-in-out infinite',
            animationDelay: '0.6s',
            boxShadow: '0 0 24px rgba(45,109,181,0.6)',
          }} />
          {/* Orange — bottom-right */}
          <div style={{
            position: 'absolute', width: 34, height: 34, background: '#e8a020',
            borderRadius: 6, bottom: 0, right: 0,
            animation: 'll-tileFlip 2s ease-in-out infinite',
            animationDelay: '0.9s',
            boxShadow: '0 0 24px rgba(232,160,32,0.6)',
          }} />
        </div>

        {/* Shimmer label */}
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: 13, fontWeight: 700,
            color: 'transparent',
            letterSpacing: 2, textTransform: 'uppercase',
            fontFamily: 'Verdana, sans-serif',
            background: 'linear-gradient(90deg, #cc2b2b, #3aaa5c, #2d6db5, #e8a020, #cc2b2b)',
            backgroundSize: '300% auto',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: 'll-shimmerText 2.5s linear infinite',
          }}>
            {message}
          </div>
        </div>

        {/* Dot indicators */}
        <div style={{ display: 'flex', gap: 8 }}>
          {['#cc2b2b', '#3aaa5c', '#2d6db5', '#e8a020'].map((c, i) => (
            <div key={i} style={{
              width: 8, height: 8, borderRadius: '50%', background: c,
              animation: 'll-dotPulse 1.2s ease-in-out infinite',
              animationDelay: `${i * 0.2}s`,
            }} />
          ))}
        </div>

      </div>

      <style>{`
        @keyframes ll-tileFlip {
          0%   { transform: rotateY(0deg) scale(1); opacity: 1; }
          25%  { transform: rotateY(90deg) scale(0.8); opacity: 0.3; }
          50%  { transform: rotateY(180deg) scale(1); opacity: 1; }
          75%  { transform: rotateY(270deg) scale(0.8); opacity: 0.3; }
          100% { transform: rotateY(360deg) scale(1); opacity: 1; }
        }
        @keyframes ll-shimmerText {
          0%   { background-position: 0% center; }
          100% { background-position: 300% center; }
        }
        @keyframes ll-dotPulse {
          0%, 100% { transform: scale(1); opacity: 0.4; }
          50%       { transform: scale(1.6); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LogoLoader;
